/**
 * 補正サーバーの配信を動画で 1 本（Issue #801 で pages/ShootSetup.js から切り出した）。メインの縦積み（`/live/stream?preview=1`）や
 * 席ごとの配信（`/live/stream?seat=N`。見ているあいだだけ補正サーバーが作る）を見る。
 * VideoDecoder が無いブラウザ・テスト（live が false）では動画を出さず一言だけ。
 */
import { useRef } from 'react';
import { useLiveVideo } from './liveCorrect';

const canDecode = () => typeof VideoDecoder !== 'undefined';   // eslint-disable-line no-undef

export default function LiveStream({ url, live, label, testId, maxWidth = 480 }) {
  const ref = useRef(null);
  const video = live && canDecode();
  useLiveVideo(ref, url, video);
  return (
    <div style={{ display: 'grid', gap: 4 }}>
      <div style={{ fontSize: 12, color: '#b8c0d4' }}>{label}</div>
      {video ? <canvas ref={ref} data-testid={testId} style={{ width: '100%', maxWidth, display: 'block', background: '#000' }} />
        : <div style={{ fontSize: 12, color: '#8a93a8' }}>このブラウザでは動画を出せません（VideoDecoder が無い）</div>}
    </div>
  );
}
